var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSlide } from "../../slidesOps/createSlide";
// import { loadDirectoryCSV } from "../../../directory/csv/loadDirectoryCSV";
// import { CSV_URL } from "../../../directory/csv/url";
import { scrapeDirectoryHTML } from "../../../directory/scrape/scrapeDirectoryHTML";
import { familyColumns, familyColumnsAlt, familyRows, familyRowsAlt, } from "./_vars";
import "./index.scss";
export function slideDirectory() {
    return __awaiter(this, void 0, void 0, function* () {
        const { families } = yield scrapeDirectoryHTML();
        // const { families } = await loadDirectoryCSV(CSV_URL);
        const familyIDs = Object.keys(families);
        const familyCount = familyIDs.length;
        const pauseBase = 1000;
        let famCols = familyColumns;
        let famRows = familyRows;
        let pauseBeforeNext = pauseBase;
        let pageCount = 0;
        let layoutClass = "";
        let html = `
        <section data-autoslide="${150}">
            <div class="families">
    `;
        if (familyCount % (familyRows * familyColumns) < familyColumns) {
            famCols = familyColumnsAlt;
            famRows = familyRowsAlt;
            layoutClass = "families--layout--alt";
        }
        for (let i = 0; i < familyCount; i++) {
            pageCount++;
            const family = families[familyIDs[i]];
            const familyName = family["family-name"].split(" (");
            pauseBeforeNext = pageCount * pauseBase;
            if (i > 0 && i % (famRows * famCols) === 0) {
                html += `
                        <div class="fragment" data-autoslide="${pauseBeforeNext}"></div>
                    </div>
                </section>
                <section data-autoslide="${150}">
                    <div class="families">
            `;
                pageCount = 0;
            }
            html += `
            <div class="family fragment fade-up" data-autoslide="${150}" style="width: ${100 / famCols}%">
                <div class="family__inner">
                    <div class="family__photo-container">
                        <img class="family__photo" alt="${family["family-name"]}" src="${family["family-photo-url"] ||
                `https://dummyimage.com/600x400/eee/333&text=${family["family-name"][0]}`}" />
                    </div>
                    <p class="family__name text-color">${familyName[0]}</p>
                    ${familyName[1]
                ? `<p class="family__children text-color text-color--secondary">${familyName[1].replace(")", "")}</p>`
                : ""}
                </div>
            </div>
        `;
        }
        html += `
                <div class="fragment" data-autoslide="${pauseBeforeNext}"></div>
            </div>
        </section>
    `;
        console.log(html);
        createSlide({
            center: "false",
            wrap: "false",
            classList: layoutClass,
            html: html,
            background: { color: "#ffffff" },
        }, "families");
    });
}
